import { getFrontendUserConfiguration } from '@shared/user-configuration';
import { logger } from '@luna/logger';

/**
 * Plays the default sound if the sounds are enabled
 * in the settings. Returns true or false according to
 * the sound settings.
 *
 * @method playSound
 * @return {Boolean}
 */
export const playSound = (soundId: string) => {
    const soundEnabled = getFrontendUserConfiguration().userConfiguration?.soundEnabled;

    if (soundEnabled === true) {
        // Perhaps audio not supported
        try {
            const newSound = new Audio(`/sound/${soundId}.mp3`);
            if (newSound) {
                newSound.play().catch((error) => {
                    logger.error('Unable to play sound', error);
                });
            }
        } catch {
            return false;
        }
    }

    return soundEnabled;
};
